import { Button } from "antd-mobile"
import React, { ComponentProps, FC } from "react"
type ButtonProps = ComponentProps<typeof Button>

interface BaseButtonProps extends ButtonProps {
}
/**
 * 基础按钮
 * @param props.restProps 原有属性
 * @returns 
 */
const BaseButton: FC<BaseButtonProps> = (props) => {
  const { ...restProps } = props;
  return (<Button {...restProps}></Button>);
}
export default BaseButton;